import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const SwitchIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.8335 6.66671L12.5002 10H15.0002C15.0002 12.7584 12.7585 15 10.0002 15C9.1585 15 8.3585 14.7917 7.66683 14.4167L6.45016 15.6334C7.47516 16.2834 8.69183 16.6667 10.0002 16.6667C13.6835 16.6667 16.6668 13.6834 16.6668 10H19.1668L15.8335 6.66671ZM5.00016 10C5.00016 7.24171 7.24183 5.00004 10.0002 5.00004C10.8418 5.00004 11.6418 5.20837 12.3335 5.58337L13.5502 4.36671C12.5252 3.71671 11.3085 3.33337 10.0002 3.33337C6.31683 3.33337 3.3335 6.31671 3.3335 10H0.833496L4.16683 13.3334L7.50016 10H5.00016Z"
                fill={props.htmlColor ?? '#21272E'}
            />
        </SvgIcon>
    );
};
